import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { useFavorites } from "../hooks/useFavorites";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export default function Favorites() {
  const { favorites, removeFavorite } = useFavorites();

  return (
    <div
      className="max-w-5xl mx-auto px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-32"
      data-testid="favorites-page"
    >
      <div
        className="text-xs uppercase tracking-[0.35em] mb-6"
        style={{ color: "var(--rincon-secondary)" }}
      >
        Tu rincón
      </div>
      <h1
        className="font-display text-5xl md:text-7xl tracking-tight"
        style={{ color: "var(--rincon-text)" }}
      >
        Guardados <em className="italic">para leer luego</em>.
      </h1>
      <p
        className="font-body italic mt-6 max-w-2xl text-xl leading-relaxed"
        style={{ color: "var(--rincon-text-muted)" }}
      >
        Los textos que has marcado con el corazón. Se guardan solo en este
        dispositivo, sin necesidad de cuenta.
      </p>

      {favorites.length === 0 ? (
        <div
          className="py-24 text-center font-display italic text-2xl"
          style={{ color: "var(--rincon-text-muted)" }}
          data-testid="favorites-empty"
        >
          Aún no has guardado ningún texto. Pulsa el{" "}
          <Heart className="inline w-5 h-5 align-text-bottom" /> al leer para
          guardarlo aquí.
        </div>
      ) : (
        <ul className="mt-14 space-y-8" data-testid="favorites-list">
          {favorites.map((t) => (
            <li
              key={t.id}
              className="flex items-start justify-between gap-6 border-b pb-8"
              style={{ borderColor: "var(--rincon-border)" }}
              data-testid={`favorite-item-${t.id}`}
            >
              <div className="flex-1">
                <div
                  className="text-[10px] uppercase tracking-[0.25em] mb-2 font-semibold"
                  style={{ color: "var(--rincon-secondary)" }}
                >
                  {t.main_category} · {t.subcategory} · {formatDate(t.created_at)}
                </div>
                <Link
                  to={`/texto/${t.id}`}
                  className="font-display text-2xl md:text-3xl tracking-tight transition-colors hover:text-[var(--rincon-primary)]"
                  style={{ color: "var(--rincon-text)" }}
                  data-testid={`favorite-title-${t.id}`}
                >
                  {t.title}
                </Link>
                {t.epigraph ? (
                  <p
                    className="mt-2 font-body italic text-base"
                    style={{ color: "var(--rincon-secondary)" }}
                  >
                    «{t.epigraph}»
                  </p>
                ) : null}
              </div>
              <button
                type="button"
                onClick={() => removeFavorite(t.id)}
                data-testid={`favorite-remove-${t.id}`}
                aria-label="Quitar de guardados"
                className="shrink-0 p-2 rounded-full transition-colors hover:bg-[var(--rincon-surface)]"
                style={{ color: "var(--rincon-text-muted)" }}
              >
                <X className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
